<template>
    <div class="promotions__wrapper">
        <div class="promotions__grid">
            <PromotionItem
                v-for="(promotion, index) in promotions"
                :key="index"
                :promotion="promotion"
            />
        </div>
    </div>
</template>
<script>
    import PromotionItem from './PromotionItem';
    export default {
        props: {
            promotions: {
                type: Array,
                required: true,
            },
        },
        components: {
            PromotionItem,
        },
    };
</script>
